import { render } from "./IdmlConfiguration.vue?vue&type=template&id=5881d74f&scoped=true&ts=true"
import script from "./IdmlConfiguration.vue?vue&type=script&lang=ts"
export * from "./IdmlConfiguration.vue?vue&type=script&lang=ts"

import "./IdmlConfiguration.vue?vue&type=style&index=0&id=5881d74f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5881d74f"]])

export default __exports__